import { createWebHistory, createRouter } from 'vue-router'

import HelloWorld from './components/HelloWorld.vue'
import ButtonPanel from './components/ButtonPanel.vue'
import QueuePanel from '@/components/QueuePanel.vue'
import Settings from '@/components/Settings.vue'
import Cameras from './components/Cameras.vue'

import { isUserAdmin } from '@/utils/telegram'

function settingsGuard(to, from, next) {
    if (isUserAdmin()) {
        next()
    } else {
        next('/')
    }
}

const routes = [
    { path: '/', component: HelloWorld, props: (route) => ({ msg: route.query.q }) },
    { path: '/about', component: ButtonPanel },
    { path: '/queue', component: QueuePanel },
    { path: '/cameras', component: Cameras },
    { path: '/settings', component: Settings, beforeEnter: settingsGuard }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

export default router
